module.exports = __webpack_public_path__ + "static/media/fly0016.f1861e06.webp";